import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import getSharedByDetails from 'utils/asset/getSharedByDetails';
import { checkIsPlaylist } from 'types/content/utils';
import FriendlyDuration from 'components/FriendlyDuration';
import { VerticalCard, InfoIcons, ExternalLink } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import InlineList from 'components/InlineList';
import { GoalPill, SharedByPill } from 'components/Pill';
import { useDismissShare, useCardContentDetails } from 'components/ContentCards/controllers';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import useOnWebAssetClick from './useOnWebAssetClick';
import getHubContentLink from './getHubContentLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SmartContentCard = function SmartContentCard(_ref) {
  var content = _ref.content,
    _ref$isShared = _ref.isShared,
    isShared = _ref$isShared === void 0 ? false : _ref$isShared,
    _ref$thumbnailDimensi = _ref.thumbnailDimensions,
    thumbnailDimensions = _ref$thumbnailDimensi === void 0 ? DIMENSIONS.VERTICAL_CARD : _ref$thumbnailDimensi,
    isFocusDisabled = _ref.isFocusDisabled,
    _ref$isFeedItem = _ref.isFeedItem,
    isFeedItem = _ref$isFeedItem === void 0 ? false : _ref$isFeedItem,
    _ref$useCustomId = _ref.useCustomId,
    useCustomId = _ref$useCustomId === void 0 ? false : _ref$useCustomId;
  var id = content.id,
    name = content.name,
    description = content.description,
    goal = content.goal,
    user_rated_like = content.user_rated_like,
    commentCount = content.commentCount,
    commentCountUser = content.commentCountUser,
    rating_count = content.rating_count,
    thumbnailId = content.thumbnailId,
    parentContentId = content.parentContentId;
  var isPlaylist = checkIsPlaylist(content);
  var badge = isPlaylist ? content.badge : undefined;
  var hasUserBadge = isPlaylist ? content.hasUserBadge : false;
  var isSaved = isPlaylist ? content.isSaved : false;
  var audience = isPlaylist ? content.audience || 'all' : 'all';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useDismissShare = useDismissShare(id),
    dismissShare = _useDismissShare.dismissShare;
  var _useOnWebAssetClick = useOnWebAssetClick(),
    onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var _useCardContentDetail = useCardContentDetails(content),
    contentCount = _useCardContentDetail.contentCount,
    duration = _useCardContentDetail.duration,
    progress = _useCardContentDetail.progress,
    type = _useCardContentDetail.type,
    icon = _useCardContentDetail.icon;
  var qaId = useUniqueId(useCustomId ? id === null || id === void 0 ? void 0 : id.toString() : undefined);
  var link = getHubContentLink({
    id: id,
    type: type.value,
    parentId: parentContentId
  });
  var contentCountReadout = contentCount.value ? contentCount.readable : undefined;
  var menuItems = isShared ? [{
    value: t('actions_discard'),
    onSelect: dismissShare
  }] : undefined;
  var sharedBy;
  if (isShared) {
    sharedBy = getSharedByDetails(content);
  }
  return /*#__PURE__*/_jsx(VerticalCard, {
    link: link,
    icon: icon,
    id: qaId,
    imageSource: getPictureUrl({
      id: thumbnailId,
      dimensions: thumbnailDimensions
    }),
    isFocusDisabled: isFocusDisabled,
    badge: badge,
    hasUserBadge: hasUserBadge,
    isFeedItem: isFeedItem,
    title: name,
    subtitle: /*#__PURE__*/_jsxs(InlineList, {
      as: "span",
      itemAs: "span",
      splitBy: "dot",
      display: "inline",
      children: [type.readable, contentCountReadout, duration > 0 && /*#__PURE__*/_jsx(FriendlyDuration, {
        value: duration
      }), type.value !== 'topic' && progress && /*#__PURE__*/_jsx(ContentProgressCircle, {
        contentName: name,
        progress: progress,
        infoReadout: "short",
        scale: 5 / 6
      }), content.type === 'web' && !!content.webUrl && content.openInIframe === false && /*#__PURE__*/_jsx(ExternalLink, {
        webUrl: content.webUrl,
        assetName: content.name,
        onWasClicked: function onWasClicked() {
          return onWebAssetClick({
            type: content.type,
            markAsDoneMode: isPlaylist ? undefined : content.markAsDoneMode,
            userContentStatus: content.userContentStatus,
            contentId: content.id
          });
        }
      })]
    }),
    description: description,
    menuItems: menuItems,
    infoIcons: /*#__PURE__*/_jsx(InfoIcons, {
      isSaved: isSaved,
      visibility: audience === 'admin' ? 'private' : undefined,
      likeCount: rating_count,
      commentCount: commentCount,
      commentCountUser: commentCountUser,
      hasUserLiked: user_rated_like
    }),
    priorityPill: goal ? /*#__PURE__*/_jsx(GoalPill, {
      goal: goal
    }) : isShared ? /*#__PURE__*/_jsx(SharedByPill, {
      pictureUrl: sharedBy.pictureUrl,
      children: sharedBy.label
    }) : undefined
  });
};
export default SmartContentCard;